module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-14.323a5061.png";